// extracted by mini-css-extract-plugin
export default {"gap_50":"Authors_gap_50__7fgmi","gap_20":"Authors_gap_20__C9h5x","card_item_container":"Authors_card_item_container__r3maA","padding_0_20":"Authors_padding_0_20__WDABf"};